import axios from 'axios';
import type { IAppointmentTextLog } from '@bb/domain/dist/types';
import type { AppointmentDeliveryLog } from './getEmailDeliveryLog';

export type AppointmentSMSDeliveryLog = AppointmentDeliveryLog & {
  mobileNumber: string;
};

const getSmsDeliveryLog = async (appointmentId: string) => {
  const { data } = await axios.get<IAppointmentTextLog[]>(
    `/appointment/${appointmentId}/texts`,
  );

  return data.map(log => ({
    recipient: `${log.contactFirstName} ${log.contactLastName}`,
    eventType: log.messageType,
    status: log.messageStatus,
    time: new Date(log.statusLastUpdatedAt!),
    mobileNumber: log.to,
  })) as AppointmentSMSDeliveryLog[];
};

export default getSmsDeliveryLog;
